import React, { useState } from 'react';
import '../styles/AuditTypeModal.css';
import thermaxLogo from "../assets/Thermax-Logo.wine01.png";

function ControlCategoryModal({ onSelect, allowedCategories }) {
  const options = [
    { value: 'ITGC', label: 'ITGC (IT General Controls)' },
    { value: 'ITAC', label: 'ITAC (IT Application Controls)' }
  ];

  // allowedCategories is null while still loading (or for unrestricted
  // staff/superuser accounts) - treat as "everything allowed" in that case.
  const isAllowed = (value) => {
    if (!allowedCategories) return true;
    return value === 'ITGC' ? allowedCategories.itgc_allowed !== false : allowedCategories.itac_allowed !== false;
  };

  const defaultCategory = isAllowed('ITGC') ? 'ITGC' : 'ITAC';
  const [selectedCategory, setSelectedCategory] = useState(defaultCategory);
  const [error, setError] = useState('');

  const handleChoose = (value) => {
    if (!isAllowed(value)) {
      const otherLabel = value === 'ITGC' ? 'ITAC' : 'ITGC';
      setError(`You only have access to ${otherLabel}. Please select ${otherLabel} to continue.`);
      return;
    }
    setError('');
    setSelectedCategory(value);
  };

  return (
    <div className="audit-type-overlay">
      <div className="audit-type-modal">
        <img src={thermaxLogo} alt="Thermax" className="audit-type-logo" />
        <h2>Select Control Type</h2>
        <p>Choose whether you want to work in ITGC or ITAC for this session.</p>

        <div className="audit-type-options">
          {options.map((option) => (
            <label
              key={option.value}
              className={`audit-type-option ${selectedCategory === option.value ? 'active' : ''} ${!isAllowed(option.value) ? 'audit-type-option--disabled' : ''}`}
            >
              <input
                type="radio"
                name="controlCategory"
                value={option.value}
                checked={selectedCategory === option.value}
                onChange={() => handleChoose(option.value)}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </div>

        {error && <p className="audit-type-error-msg">{error}</p>}

        <button className="audit-type-confirm-btn" onClick={() => onSelect(selectedCategory)}>
          Continue
        </button>
      </div>
    </div>
  );
}

export default ControlCategoryModal;
